"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _pfaHero = _interopRequireDefault(require("./pfa-hero.props/pfa-hero.defaultProps"));
var _pfaHero2 = _interopRequireDefault(require("./pfa-hero.props/pfa-hero.propTypes"));
var _pfaHeroBackground = _interopRequireDefault(require("./pfa-hero-background"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps;
var PFAHero = /*#__PURE__*/function (_React$Component) {
  function PFAHero() {
    return _React$Component.apply(this, arguments) || this;
  }
  (0, _inheritsLoose2["default"])(PFAHero, _React$Component);
  PFAHero.resourceType = function resourceType() {
    return 'PFA_Hero_1_0_0';
  };
  var _proto = PFAHero.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      data = _this$props.data,
      defaultData = _this$props.defaultData,
      isCarousel = _this$props.isCarousel,
      theme = _this$props.theme;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    return /*#__PURE__*/_react["default"].createElement(_pfaHeroBackground["default"], {
      data: _objectSpread(_objectSpread({}, componentData), {}, {
        isCarousel: isCarousel
      }),
      theme: theme
    });
  };
  return PFAHero;
}(_react["default"].Component);
PFAHero.displayName = 'PFAHero';
PFAHero.defaultProps = {
  data: _pfaHero["default"],
  defaultData: _pfaHero["default"],
  isCarousel: false
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)((0, _reactRouter.withRouter)(PFAHero));